// extracted by mini-css-extract-plugin
module.exports = {"avatar":"MediaAvatar_avatar__qWYTl","audioIcon":"MediaAvatar_audioIcon__30IP-"};